export default {
  name: 'NotFound'
};